import React, { Component } from 'react';
import './LoginStyle.css';

export default class PaymentMessage extends Component {


    constructor(props) {
        super(props);
        
        this.state =
        {
        }
    }


    render() {
        
      
        return (<div className='panel' style={{ textAlign: 'center', borderWidth: '2px', borderStyle: 'solid', width: '400px' }}>
            <span id='lblPaymentMess' style={{ color: 'red' }} dangerouslySetInnerHTML={{ __html: this.props.PaymentMessege }}></span>
                        <br />
                        <br />
                        <input id="btnPaymentMess" type="button" className="SButton" value="Close" onClick={this.props.onPaymentClick} />
                </div>              
           
        );

    }
}
 